import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["checkbox", "regionGroup"];

  connect() {
    console.log("WineRegionController connected");
    console.log("Checkbox target:", this.checkboxTarget);
    console.log("RegionGroup target:", this.regionGroupTarget);
    this.toggleRegionGroup();
  }

  toggleRegionGroup() {
    console.log("toggleRegionGroup called");
    console.log("Checkbox checked:", this.checkboxTarget.checked);
    if (this.checkboxTarget.checked) {
      console.log("Showing region group");
      this.regionGroupTarget.classList.remove("hidden");
    } else {
      console.log("Hiding region group");
      this.regionGroupTarget.classList.add("hidden");
    }
  }
}
